import React from 'react';
import { useTranslation } from 'next-i18next';
import { expansionPanelLinks } from '../data/expansion-panel-links';
import AppNavbarMenu from '../menu';
import ExpansionPanelAccordion from './accordion';
import s from './styles.module.scss';
import { Playlist } from '@/infrastructure/class/playlist';
import { useRouter } from 'next/router';
import { routes } from '@/infrastructure/const/routes';
import PlaylistMenu from '@/components/playlist/menu';

const AppNavbarExpansionPanel: React.FC = () => {
  const { t: tLinks } = useTranslation('links');
  const links = expansionPanelLinks(tLinks);

  const router = useRouter();

  const handleItemClick = (playlist: Playlist) => {
    router.push(`${routes.playlist}?id=${playlist.id}`);
  };

  return (
    <div>
      <ExpansionPanelAccordion title={tLinks('playlists')}>
        <PlaylistMenu
          menuItemClassName={s['menu-item']}
          onItemClick={handleItemClick}
        />
      </ExpansionPanelAccordion>
      {links.map((group) => (
        <ExpansionPanelAccordion key={group.title} title={group.title}>
          <AppNavbarMenu links={group.items} itemClassName={s['menu-item']} />
        </ExpansionPanelAccordion>
      ))}
    </div>
  );
};

export default AppNavbarExpansionPanel;
